var angular = require('angular');

httpService.$inject = ['$http', '$q', '$rootScope', 'serverError'];

function httpService($http, $q, $rootScope, serverError) {

  var http = function(method, urlArr, config, ignoreStatuses) {

    var success = function(response) {
      deferred.resolve(response.data);
    };

    var error = function(response) {
      console.log('Http error:', response);

      response.ignoredStatus = (ignoreStatuses || []).filter(function(status) {
        return status === response.status;
      })[0];

      if (response.status === 401) {  // 401 Unauthorized
        $rootScope.autoLogout();
      } else if (response.ignoredStatus === undefined) {
        serverError.error(response.status, response.statusText, response.data);
      }

      deferred.reject(response);
    };

    var deferred = $q.defer();

    // Default path: '/pl/api/v-1'
    var url = [process.env.BASE_URL, 'pl', 'api', 'v-1'].concat(urlArr).join('/');

    // If first element is '/' then skip default path
    if (urlArr[0] === '/') {
      urlArr.shift();
      url = [process.env.BASE_URL].concat(urlArr).join('/');
    }

    config = angular.extend({
      method: method,
      url: url
    }, config);

    if ($rootScope.auth) {

      // Show login-screen if the local token isn't valid anymore
      if ($rootScope.auth.token) {
        var tmp = $rootScope.auth.token.split(":");
        if (tmp.length === 3) {
          var validUntil = new Date(parseInt(tmp[1], 10));
          var now = new Date();
          if (validUntil.getTime() < now.getTime()) {
            $rootScope.autoLogout();
          }
        }
      }

      // Set auth-header
      config.headers = config.headers || {};
      config.headers['X-Auth-Token'] = $rootScope.auth.token;
    }

    $http(config).then(success, error);
    return deferred.promise;
  };

  this.get = function(url, params, ignoreStatuses) {
    return http('GET', url, { params: params }, ignoreStatuses);
  };

  this.post = function(url, data, ignoreStatuses) {
    return http('POST', url, { data: data }, ignoreStatuses);
  };

  this.delete = function(url, ignoreStatuses) {
    return http('DELETE', url, undefined, ignoreStatuses);
  };

  this.postMultipart = function(url, data, ignoreStatuses) {
    return http('POST', url, {
      data: data || {},
      headers: {
        'Content-Type': undefined  // Force the browser to provide the boundary by using
                                   // undefined, and not 'multipart/form-data'
      },
      transformRequest: function(data) {  // Angular serializes the data as JSON by default
        var formData = new FormData();
        for (var key in data) {
          formData.append(key, data[key]);
        }
        return formData;
      }
    }, ignoreStatuses);
  };

}

module.exports = httpService;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/http.js
 ** module id = 198
 ** module chunks = 1
 **/